export default "__VITE_ASSET__98ebcd2d__"